// extracted by mini-css-extract-plugin
export default {"bodyWrap":"delete_bodyWrap__ZDS9u","shortBtn":"delete_shortBtn__Gaq+f","shortBtnOk":"delete_shortBtnOk__qg1kf","shortBtnNotOk":"delete_shortBtnNotOk__bpWYh"};